// Shared constants for the extended (RTS) limits UI, consumed by
// LimitsContainerExtended, PlayerSetLimitBox and OperatorSetLimitBox so the two
// boxes cannot drift apart.

export const GROSS_DEPOSIT = 'gross_deposit'
export const TRUE_LOSS = 'true_loss'

export const PERIODS = ['daily', 'weekly', 'monthly']

export const PERIOD_LABEL = {
  daily: 'Max Daily',
  weekly: 'Max Weekly',
  monthly: 'Max Monthly',
}

// Human-readable label per limit type, used in user-facing copy (e.g. cap
// notifications) so the raw snake_case key is never shown to operators.
export const TYPE_LABEL = {
  [GROSS_DEPOSIT]: 'gross deposit',
  [TRUE_LOSS]: 'true loss',
}

// Fall back to the raw key so an unmapped type still produces readable-ish copy
// rather than "undefined".
export function getTypeLabel(type) {
  return TYPE_LABEL[type] || type
}
